import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import { PoolTypography, PoolTypographyProps } from '../pool-typography/pool-typography';

export const Headline = (props: PoolTypographyProps): ReactElement => (
    <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
            width: '100%',
            borderBottom: theme => `1px solid ${theme.palette.text.primary}`,
            height: 35,
            pb: { xs: 0.5, sm: 1 },
        }}
    >
        <PoolTypography variant="h6" component="h6" {...props} />
        {props.children}
    </Stack>
);
